export const WHATSAPP_ONLINE = '5517981644960';
export const WHATSAPP_PRESENCIAL = '5517997420841';

export const getWhatsappUrl = (numero: string, mensagem: string) =>
    `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;
